export const UPDATE_SEARCHLIST = 'coaSearch/updateResults'

export const RESET_FILTERS = 'coaSearch/reset'
export const RESET_RESULTS = 'coaSearch/resetTableData'

export const UPDATE_CONTROL_NO = 'coaAdd/getControlNo'
export const GET_DETAIL = 'erf/getDetails'

export const SET_CONFIRM_MODAL = 'coaSearch/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'coaSearch/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'coaSearch/showConfirmModal'

export const SET_CHANGE_APPROVER_MODAL = 'coaSearch/setChangeApproverModal'
export const HIDE_CHANGE_APPROVER_MODAL = 'coaSearch/hideChangeApproverModal'
export const SHOW_CHANGE_APPROVER_MODAL = 'coaSearch/showChangeApproverModal'

export const FETCH_EMPLOYEE_SV_DDL = 'coaSearch/setEmployeeSVDDL'

// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'coaSearch/applySearchFilter'
export const CHG_FILTER_DATA = 'coaSearch/changeFilterField'
export const CHG_FILTER_PAGE = 'coaSearch/changePage'
export const CHG_FILTER_PAGE_SIZE = 'coaSearch/changePageSize'
export const CHG_FILTER_SORT = 'coaSearch/changeSortModel'
export const IS_LOADING = 'coaSearch/isLoading'
export const CHG_SELECTED_ROWS = 'coaSearch/changeSelected'
export const HIDE_LIST_ALERT = 'coaSearch/hideAlert'
export const SET_LIST_ALERT = 'coaSearch/setAlertModal'

// ADD FORM TYPES
export const CHG_FIELD = 'coaAdd/changeField'
export const CHG_STATUS = 'coaAdd/changeStatus'
export const CHG_EMPLOYEE_ID = 'coaAdd/changeEmployeeId'
export const CHG_INCOME_ID = 'coaAdd/changeIncomeId'
export const CHG_AMOUNT = 'coaAdd/changeAmount'
export const CHG_EFFECTIVE_DATE = 'coaAdd/changeEffectiveData'
export const CHG_MEMO = 'coaAdd/changememo'
export const RESET_ADD_DATA = 'coaAdd/resetAddData'
export const UPD_ADD_ALERT = 'coaAdd/updateAlert'
export const HIDE_ADD_ALERT = 'coaAdd/hideAlert'
export const UPD_ADD_MEMO_CHAR_COUNT = 'coaAdd/updateMemoCharCount'
export const INSERT_LOADING = 'coaAdd/isLoading'
export const CHANGE_UPDATE_VALUES = 'coaAdd/changeUpdateValues'
export const FETCH_APPROVER_VALUES = 'coaAdd/fetchApproverValues'


// DETAIL FORM TYPES
export const UPD_DETAIL_TITLE = 'coaDetail/changeTitle'
export const CHG_DETAIL_DATA = 'coaDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'coaDetail/changeMode'
export const HAS_DETAIL_LOADED = 'coaDetail/hasDetailLoaded'
export const SET_DETAIL_DATA = 'coaDetail/setDetailData'
export const UPD_AMOUNT = 'coaDetail/changeAmount'
export const HIDE_DETAIL_ALERT = 'coaDetail/hideAlert'
export const UPD_DETAIL_MEMO_CHAR_COUNT = 'coaDetail/updateMemoCharCount'
export const UPD_DETAIL_DATA = 'coaDetail/updateDetailData'
export const SET_LOAN_LEDGER_DATA = 'coaDetail/seterfLedgerData'
export const SHOW_LOAN_LEDGER = 'coaDetail/showerfLedgerData'
export const HIDE_LOAN_LEDGER = 'coaDetail/hideerfLedgerData'
export const SET_DETAIL_CONFIRM_MODAL = 'coaDetail/setConfirmModal'
export const HIDE_DETAIL_CONFIRM_MODAL = 'coaDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'coaDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'coaDetail/setAlertModal'

